import { Check } from "lucide-react";
import { Link } from "react-router-dom";

import { COOKIE_CONSENT_DAYS } from "@/lib/consent";
import { routePaths } from "@/routes/routePaths";
import { useCookieConsent } from "@/hooks/useCookieConsent";

export function CookieConsentBanner() {
  const { requiresConsent, accept } = useCookieConsent();

  if (!requiresConsent) {
    return null;
  }

  return (
    <aside className="fixed bottom-3 left-3 right-3 z-40 border border-neutral-700 bg-neutral-950 p-3 text-white shadow-2xl sm:bottom-5 sm:left-5 sm:right-auto sm:w-[360px] sm:p-4">
      <div className="flex items-start gap-3">
        <div className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center bg-white text-neutral-950">
          <Check className="h-4 w-4" />
        </div>
        <div className="min-w-0 flex-1">
          <h2 className="text-sm font-semibold">Cookie consent</h2>
          <p className="mt-1 text-xs leading-5 text-neutral-300">
            We use necessary preference storage and, with your consent, advertising cookies. Consent is remembered for{" "}
            {COOKIE_CONSENT_DAYS} days.
          </p>
          <div className="mt-3 flex items-center gap-3">
            <button
              type="button"
              onClick={accept}
              className="inline-flex h-8 items-center gap-2 border border-white bg-white px-3 text-xs font-medium text-neutral-950 transition hover:bg-neutral-950 hover:text-white"
            >
              <Check className="h-3.5 w-3.5" />
              Agree
            </button>
            <Link to={routePaths.privacy} className="text-xs text-neutral-300 underline-offset-4 hover:underline">
              Privacy
            </Link>
          </div>
        </div>
      </div>
    </aside>
  );
}
